<script>
    import Fa from 'svelte-fa'
    import { faFilter, faSearchDollar } from '@fortawesome/free-solid-svg-icons'
    import { Route, Link, Router } from 'yrv'
    import Content from '../_common/content.svelte'
    import ProspectEntries from './prospect-entries.svelte'
    import ProspectFilter from './prospect-filter.svelte'
</script>

<div class="root-content">
    <div class="tab">
        <div class="inside">
            <Link class="link" href="/prospect/entries"><Fa icon={faSearchDollar} /> Prospectar</Link>
            <Link class="link" href="/prospect/filter"><Fa icon={faFilter} /> Minhas prospecções</Link>
            <div class="spacer" />
        </div>
    </div>

    <Router>
        <Route path="/entries">
            <ProspectEntries />
        </Route>
        <Route path="/filter">
            <ProspectFilter />
        </Route>
    </Router>
</div>

<style>
    .tab {
        color: rgb(var(--prospect-color));
        border-bottom-color: rgb(var(--prospect-color));
        border-bottom-width: 2px;
    }
    .tab :global([aria-current='page']) {
        background-color: rgba(var(--prospect-color), 0.9);
    }
    .inside {
        max-width: 1600px;
        margin: 0 auto;
        flex-grow: 1;
    }
</style>
